let loadingCount = 0
let isEnabled = true

export const enableLoading = () => {
  isEnabled = true
  loadingCount = 0
}

export const disableLoading = () => {
  isEnabled = false
  loadingCount = 0
}

export const showLoading = (title = '加载中...', mask = true) => {
  if (!isEnabled) return
  loadingCount++
  if (loadingCount === 1) {
    uni.showLoading({
      title: title,
      mask: mask
    })
  }
}

export const hideLoading = () => {
  if (!isEnabled) return
  setTimeout(() => {
    if (loadingCount > 0) {
      loadingCount--
    }
    if (loadingCount <= 0) {
      uni.hideLoading()
    }
  }, 100)
}
